import React from 'react';
import ArticleIcon from '@mui/icons-material/Article';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

type BlogPost = {
  title: string;
  excerpt: string;
  date?: string;
  url?: string;
  status?: string;
};

function Blog() {
  const posts = (setup.blog || []) as BlogPost[];

  if (!posts.length) {
    return null;
  }

  const upcoming = posts.filter((p) => p.status === 'upcoming' || !p.url);
  const published = posts.filter((p) => p.url && p.status !== 'upcoming');

  return (
    <MotionSection id="blog">
      <SectionHeader
        eyebrow="Writing"
        title="Engineering Articles"
        subtitle="Deep dives into architecture, integrations, and lessons from production—not tutorials."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {published.map((post) => (
          <a
            key={post.title}
            href={post.url}
            target="_blank"
            rel="noreferrer"
            className="ui-card p-5 hover:border-accent/30 transition-colors block"
          >
            {post.date && <p className="text-xs text-ink-muted mb-2">{post.date}</p>}
            <h3 className="text-base font-medium text-ink mb-2">{post.title}</h3>
            <p className="text-sm text-ink-muted leading-relaxed">{post.excerpt}</p>
          </a>
        ))}
        {upcoming.map((post) => (
          <div key={post.title} className="ui-card p-5 border-dashed opacity-90">
            <div className="flex items-center gap-2 mb-2">
              <ArticleIcon sx={{ fontSize: 16 }} className="text-ink-muted" />
              <span className="text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded bg-canvas-muted text-ink-muted border border-line">
                Coming Soon
              </span>
            </div>
            <h3 className="text-base font-medium text-ink mb-2">{post.title}</h3>
            <p className="text-sm text-ink-muted leading-relaxed">{post.excerpt}</p>
          </div>
        ))}
      </div>
    </MotionSection>
  );
}

export default Blog;
